import React, { useEffect, useState, useMemo } from "react";

export const useIsInViewport = (
  ref: React.RefObject<HTMLElement | null>,
): boolean => {
  // eslint-disable-next-line no-restricted-globals
  const isServer = typeof window === "undefined";

  const [isIntersecting, setIsIntersecting] = useState(isServer);

  const observer = useMemo(() => {
    return isServer
      ? null
      : // eslint-disable-next-line no-restricted-globals
        new window.IntersectionObserver(
          ([entry]) => setIsIntersecting(entry.isIntersecting),
          { threshold: 0.2 },
        );
  }, [isServer]);

  useEffect(() => {
    if (observer && ref?.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref, observer]);

  return isIntersecting;
};
